export default "__VITE_ASSET__RQV$GThw__"